export default {"src":"/_next/static/media/deploy-infinite.e82b1fd1.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};